---
id: go-shared-models
title: Shared models
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - models
  - shared
  - user
---

## Product Overview

### Who it serves

This shared package defines small response models reused across Go services when calling internal APIs.

### Primary workflow

Callers deserialize API responses into the shared structs to keep response shapes consistent between services.

### Business rules

Models mirror internal API contracts for user subscription status and plan data, enabling consistent parsing across services.

### Outcomes

Services can share a single set of response types instead of duplicating structs per service.

### Out of scope

Domain-specific models beyond shared user subscription responses belong in the owning services.

## Technical Overview

### Architecture flow

The package provides response structs that callers and handlers can embed in JSON decode/encode flows.

### Entry points

The exported types in `apps/micro-services/go-shared/models/user.go` include `GetUserProStatusResp`, `GetHasActiveSubResp`, `Plan`, and `GetUserActivePlansResp`.

### Key modules

`user.go` defines subscription-related response models and references `payment.PlanType` and `payment.ReziProduct`.

### Data sources and sinks

These models are populated from HTTP responses returned by internal user and subscription services.

### Integrations and side effects

There are no runtime side effects; the package only provides type definitions.

### Constraints and risks

If upstream response schemas change, these models must be updated to avoid decoding issues.

## Changelog

- 2026-01-30: Initial documentation.
